/** vue-i18n locale → 图片目录名 */
export const LOCALE_IMAGE_DIR_MAP = {
	"zh-TW": "zh-tw",
	en: "en",
};

const DEFAULT_LOCALE_IMAGE_DIR = LOCALE_IMAGE_DIR_MAP["zh-TW"];

/**
 * 将 vue-i18n 的 locale 转为图片子目录名
 * @param {string} locale
 * @returns {string}
 */
export function getLocaleImageDir(locale) {
	return LOCALE_IMAGE_DIR_MAP[locale] || DEFAULT_LOCALE_IMAGE_DIR;
}

/**
 * 从多语言图片映射中解析当前 locale 对应的图片 URL
 * @param {Record<string, string>} images - 如 { 'zh-tw': url, en: url }
 * @param {string} locale - 当前语言，如 'zh-TW' | 'en'
 * @param {string} [fallbackDir='zh-tw'] - 兜底目录
 * @returns {string}
 */
export function resolveLocaleImage(images, locale, fallbackDir = DEFAULT_LOCALE_IMAGE_DIR) {
	const dir = getLocaleImageDir(locale);
	return images[dir] ?? images[fallbackDir] ?? Object.values(images)[0] ?? "";
}

/**
 * 将 import.meta.glob 结果转为 { 'load.png': { 'zh-tw': url, en: url } } 映射
 * 目录结构：{baseDir}/{zh-tw|en}/{fileName}
 * @param {Record<string, string>} globModules
 * @returns {Record<string, Record<string, string>>}
 */
export function createLangImgMapFromGlob(globModules) {
	const map = {};

	for (const [path, url] of Object.entries(globModules)) {
		const match = path.match(/\/(zh-tw|en)\/([^/]+)$/i);
		if (!match) continue;

		const [, dir, fileName] = match;
		if (!map[fileName]) {
			map[fileName] = {};
		}
		map[fileName][dir.toLowerCase()] = url;
	}

	return map;
}

/**
 * 按文件名获取多语言图片（需配合 createLangImgMapFromGlob 使用）
 * @param {Record<string, Record<string, string>>} imageMap
 * @param {string} fileName
 * @param {string} locale
 * @param {string} [fallbackDir]
 * @returns {string}
 */
export function getLangImg(imageMap, fileName, locale, fallbackDir = DEFAULT_LOCALE_IMAGE_DIR) {
	return resolveLocaleImage(imageMap[fileName] || {}, locale, fallbackDir);
}
